import React, { useState, useEffect } from 'react';

import "./sourdough.css"
import { useApiGet, useApiSubmit } from "../../api_client";
import { decodeJwt } from '../../utils';
const SOURDOUGH_RECIPE_API_ENDPOINT = "/api/sourdough/recipe"

const RecipeForm = ({ token }) => {
  const [name, setName] = useState('');
  const [review, setReview] = useState('');
  const [recipe, setRecipe] = useState('');
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const { submitData, loading } = useApiSubmit();

  // Handle image selection and preview
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      // Create a preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');

    try {
      // Create a FormData object to handle the file upload
      const formData = new FormData();
      formData.append('name', name);
      formData.append('review', review);
      formData.append('recipe', recipe);
      formData.append('image', image);
      console.log(formData)


      // Define your custom headers in the options object
      const options = {
        headers: {
          'Authorization': 'Bearer ' + token
        }
      };

      // Use the submitData function with 'postFormData' method
      const data = await submitData(
        SOURDOUGH_RECIPE_API_ENDPOINT,
        formData,
        'postFormData',  // Using the FormData specific method
        options
      );

      // Clear the form and show success message
      setName('');
      setReview('');
      setRecipe('');
      setImage(null);
      setPreview('');
      setMessage('Recipe uploaded successfully!');
    } catch (error) {
      setMessage(`Error: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="recipe-form-container">
      <h2>Add New Sourdough Recipe</h2>
      {message && <div className={message.includes('Error') ? 'error-message' : 'success-message'}>{message}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Recipe Name</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="review">Review</label>
          <textarea
            id="review"
            value={review}
            onChange={(e) => setReview(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="recipe">Recipe Steps</label>
          <textarea
            id="recipe"
            value={recipe}
            onChange={(e) => setRecipe(e.target.value)}
            placeholder="- 310g Water, 500g White (62%)&#10;- 1.5hr Autolyse&#10;- etc."
            required
            rows={6}
          />
        </div>

        <div className="form-group">
          <label htmlFor="image">Bread Image</label>
          <input
            type="file"
            id="image"
            accept="image/*"
            onChange={handleImageChange}
            required
          />
          {preview && (
            <div className="image-preview">
              <img src={preview} alt="Preview" />
            </div>
          )}
        </div>

        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Uploading...' : 'Submit Recipe'}
        </button>
      </form>
    </div>
  );
};


const SourdoughTile = ({ recipe }) => {
  // Convert recipe string to an array of items
  const recipeSteps = recipe.instructions.split('\\n').map(step => step.trim());

  return (
    <div className="sourdough-tile">
      <div className="sourdough-image">
        <img src={recipe.image_link} alt={recipe.name} />
      </div>
      <div className="sourdough-content">
        <h2 className="sourdough-title">{recipe.name}</h2>
        <p className="sourdough-review">Review: {recipe.review}</p>
        <div className="sourdough-recipe">
          <h3>Recipe</h3>
          <ul>
            {recipeSteps.map((step, index) => (
              <li key={index}>{step.replace('- ', '')}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export const Sourdough = () => {
  const [showAddForm, setShowAddForm] = useState(false);
  const { data: recipes, loading, error, refetch } = useApiGet(SOURDOUGH_RECIPE_API_ENDPOINT, {}, [])
  const [loggedIn, setLoggedIn] = useState(false);
  const [token, setToken] = useState(null);

  useEffect(() => {
    let token = localStorage.getItem("euans_website")
    if (token !== null) {
      setLoggedIn(decodeJwt(token));
      setToken(token);
    }
  }, []);


  // Handle loading state
  if (loading) {
    return (
      <div className="sourdough-loading">
        <div className="loading-spinner"></div>
        <p>Loading your sourdough recipes...</p>
      </div>
    );
  }

  // Handle error state
  if (error) {
    return (
      <div className="sourdough-error">
        <h3>Oh no! Something went wrong</h3>
        <p>{error}</p>
        <button onClick={refetch}>Try Again</button>
      </div>
    );
  }

  // If no recipes are found
  if (!recipes || recipes.length === 0) {
    return (
      <div className="sourdough-empty">
        <h3>No recipes found</h3>
        <p>Add your first sourdough recipe to get started!</p>
      </div>
    );
  }

  if (recipes) {
    console.log(recipes.recipes)
  }

  return (
    <div className="sourdough_home">
      {loggedIn && <button className='add_recipe_button' onClick={() => setShowAddForm(!showAddForm)}>Add Recipe</button>}
      <div className='sourdough_list'>

        {showAddForm && <RecipeForm token={token} />}
        {!showAddForm && recipes.recipes.map((recipe) => <SourdoughTile recipe={recipe} key={recipe.id} />)}
      </div>
    </div>
  )
}
